import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { faqs } from "@/data/content";

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="bg-paper py-24 lg:py-36">
      <div className="max-w-4xl mx-auto px-5 lg:px-8">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
          className="eyebrow text-brandblue mb-6"
        >
          Domande frequenti
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7 }}
          className="font-serif font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.12] mb-12"
        >
          Tutto chiaro, <span className="italic text-brandblue">prima di iniziare</span>
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
        >
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-ink/10" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-serif font-semibold text-lg lg:text-xl py-6 hover:text-brandblue hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-ink/65 leading-relaxed text-base pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
